const IS_VISIBLE = 'is-visible'

const cookieModal = document.querySelector('.js-cookie-notice')
const cookieAcceptBtn = cookieModal.querySelector('.js-cookie-btn')

const setCookie = function setCookie(cname, cvalue, exdays) {
  let d = new Date()
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000)
  let expires = 'expires=' + d.toUTCString()
  document.cookie = `${cname}=${cvalue};${expires};path=/`
}

const getCookie = function (cname) {
  let name = cname + '='
  let ca = document.cookie.split(';')
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i]
    while (c.charAt(0) == ' ') {
      c = c.substring(1)
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length)
    }
  }
  return ''
}

const checkCookie = function () {
  let cookieConsent = getCookie('cookieConsent')
  if (cookieConsent != '') {
    return
  } else {
    cookieModal.classList.add(IS_VISIBLE)
  }
}

cookieAcceptBtn.addEventListener('click', function () {
  cookieModal.classList.remove(IS_VISIBLE)
  setCookie('cookieConsent', true, 365)
})

checkCookie()
